<clr-dropdown>
  <button class="nav-icon dropdown-trigger" clrDropdownTrigger>
    <clr-icon shape="tasks" size="22" [class.has-alert]="hasNotification$ | async"></clr-icon>
  </button>
  <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
    <div class="notifications-container" *ngIf="hasNotification$ | async">
      <b class="notifications-header">Повідомлення</b>
      <a class="notification-item" clrDropdownItem
         *ngFor="let notification of notifications | async"
         (click)="selectNotification(notification)">
            <span class="item-icon">
            <clr-icon shape="warning-standard" size="16"></clr-icon>
            </span>
        <span class="notification-message">
              {{messages[notification.notificationType.name]}}
            </span>
      </a>
      <div class="btn-container">
        <button class="btn btn-warning-outline"
                clrDropdownItem
                (click)="clearNotifications()">
          <clr-icon shape="trash" class="is-solid"></clr-icon>
          ВИДАЛИТИ УСІ СПОВІЩЕННЯ
        </button>
      </div>
    </div>
    <span *ngIf="!(hasNotification$ | async)" class="empty-message">Немає повідомлень</span>
  </clr-dropdown-menu>
</clr-dropdown>
